import { render, staticRenderFns } from "./Report-stranger.vue?vue&type=template&id=77d36ced"
import script from "./Report-stranger.vue?vue&type=script&lang=js"
export * from "./Report-stranger.vue?vue&type=script&lang=js"
import style0 from "./Report-stranger.vue?vue&type=style&index=0&id=77d36ced&prod&lang=scss"
import style1 from "./Report-stranger.vue?vue&type=style&index=1&id=77d36ced&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports